import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { ContactRecord } from '../entities/records';
import * as selectors from '../entities/Contact/selectors';

function mapStateToProps(state, { contactId }) {
  return {
    contact: selectors.contactById(state, contactId),
  };
}

export default compose(
  setPropTypes({
    contactId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    contact: PropTypes.instanceOf(ContactRecord),
  }),
)(mapStateToProps);
